import { ChangeDetectorRef, Component } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-nonadmin',
    templateUrl: './nonadmin.component.html',
    styleUrls: ['./nonadmin.component.scss'],
    standalone: false
})
export class NonadminComponent {
  constructor(private userInfoService: UserInfoService,private cd:ChangeDetectorRef) {
    
  }
  enablepage:any;
  ngOnInit() {
    
   
  }
}
